'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Configuration = require('./configuration');
var Proxy = require('./proxy');
var Resource = require('./resource');
var SimpleLogger = require('./simple-logger');

// Environment represents one of demo, QA or live.
//
// It provides methods to ...
//
// 1. Send all calls via a proxy server
// 2. Authenticate a user's credentials
// 3. Construct or retrieve a named resource
//
// Other available methods are ...
//
// getCredentialsUsing() specifies a callback to
//   retrieve username & password
//
// handleFailedAuthenticationUsing() specifies a
//   callback to handle incorrect credentials.
//
// deauthenticate() to invalidate the authentication
//   token.
//
// reauthenticate() to log in when a user's session
//   has expired.
//
// verbose() allows you to turn on lots of logging
//   for debugging purposes.
//
// withHost() allows overriding of the default host URL
//   provided by Environments.
//
// withConfigService() allows overriding of the default
//   configuration provided by Environments.

var Environment = function () {
    function Environment(_ref) {
        var name = _ref.name,
            host = _ref.host,
            application = _ref.application,
            configPort = _ref.configPort,
            xmlHttpRequest = _ref.xmlHttpRequest,
            config = _ref.config;

        _classCallCheck(this, Environment);

        this.name = name;
        this.application = application;
        this.configPort = configPort;

        this.host = configPort ? host + ':' + configPort : host;

        this.xmlHttpRequest = xmlHttpRequest;

        this.setConfigService();

        this.authenticationService = '@AuthenticationGatewayEndpoint';

        this.log = new SimpleLogger();

        this.log.includeProfiling();

        // Authentication housekeeping

        this.username = undefined;
        this.password = undefined;

        this.credentialsGatherer = undefined;
        this.requireAuthentication = true;
        this.authToken = undefined;
        this.JWT = undefined;
        this.userType = undefined;
        this.callProxy = undefined;

        this.requestInterceptors = [];
        this.responseInterceptors = [];

        this.chatty = false;

        this.numberOfPendingRequests = 0;

        // Registered resources

        this.resources = {};

        this.configuration = new Configuration(this, this.configService, this.authenticationService, this.xmlHttpRequest, config);

        // Some constants to make calls to Resources.initialise()
        // in the React boilerplate more intelligible.

        this.REQUIRE_AUTHENTICATION = true;
        this.BYPASSS_AUTHENTICATION = false;
    }

    _createClass(Environment, [{
        key: 'setConfigService',
        value: function setConfigService() {
            this.configService = this.host;

            this.configService += '/ConfigurationGateway/v2/applications/' + this.application;

            if (this.configuration) {
                this.configuration.configService = this.configService;
            }
        }
    }, {
        key: 'incrementPendingRequests',
        value: function incrementPendingRequests() {
            this.numberOfPendingRequests += 1;

            if (this.chatty) {
                this.log.warn('Environment("' + this.name + '") - number of pending requests = ' + this.numberOfPendingRequests);
            }
        }
    }, {
        key: 'decrementPendingRequests',
        value: function decrementPendingRequests() {
            if (this.numberOfPendingRequests > 0) {
                this.numberOfPendingRequests -= 1;

                if (this.chatty) {
                    this.log.warn('Environment("' + this.name + '") - number of pending requests = ' + this.numberOfPendingRequests);
                }
            } else {
                // this.log.warn(`Environment("${this.name}").decrementPendingRequests() - there are no pending requests!`);
            }
        }
    }, {
        key: 'havePendingRequests',
        value: function havePendingRequests() {
            return this.numberOfPendingRequests > 0;
        }
    }, {
        key: 'setConfiguration',
        value: function setConfiguration(values) {
            this.configuration.setValues(values);

            if (this.configuration.environment.name === 'local') {
                this.log.debug('Environment.setConfiguration() - setting config to ...', values);
            }

            return this;
        }
    }, {
        key: 'profileConfiguration',
        value: function profileConfiguration(value) {
            this.configuration.profileConfiguration(value);
        }
    }, {
        key: 'profileAuthentication',
        value: function profileAuthentication(value) {
            this.configuration.profileAuthentication(value);
        }
    }, {
        key: 'addRequestInterceptor',
        value: function addRequestInterceptor(interceptor) {
            this.requestInterceptors.push(interceptor);

            this.eachResource(function (r) {
                return r.addRequestInterceptor(interceptor);
            });

            return this;
        }
    }, {
        key: 'addResponseInterceptor',
        value: function addResponseInterceptor(interceptor) {
            this.responseInterceptors.push(interceptor);

            this.eachResource(function (r) {
                return r.addResponseInterceptor(interceptor);
            });

            return this;
        }
    }, {
        key: 'removeRequestInterceptor',
        value: function removeRequestInterceptor(interceptor) {
            var index = this.requestInterceptors.indexOf(interceptor);

            if (index < 0) {
                this.log.error('Environment["' + this.name + '"].removeRequestInterceptor() - failed to find the interceptor');
            } else {
                this.requestInterceptors.splice(index, 1);

                this.eachResource(function (r) {
                    return r.removeRequestInterceptor(interceptor);
                });
            }

            return this;
        }
    }, {
        key: 'removeResponseInterceptor',
        value: function removeResponseInterceptor(interceptor) {
            var index = this.responseInterceptors.indexOf(interceptor);

            if (index < 0) {
                this.log.error('Environment["' + this.name + '"].removeRequestInterceptor() - failed to find the interceptor');
            } else {
                this.responseInterceptors.splice(index, 1);

                this.eachResource(function (r) {
                    return r.removeResponseInterceptor(interceptor);
                });
            }

            return this;
        }
    }, {
        key: 'verbose',
        value: function verbose(value) {
            if (value === undefined) {
                value = true;
            }

            this.chatty = value;

            this.eachResource(function (r) {
                return r.verbose(value);
            });

            if (this.configuration) {
                this.configuration.verbose(value);
            }

            return this;
        }
    }, {
        key: 'profile',
        value: function profile(value) {
            if (value === undefined) {
                value = true;
            }

            this.profileCallDuration = value;

            this.eachResource(function (r) {
                return r.profile(value);
            });

            return this;
        }
    }, {
        key: 'setCredentials',
        value: function setCredentials(username, password) {
            this.username = username;
            this.password = password;
        }
    }, {
        key: 'profileCalls',
        value: function profileCalls(value) {
            if (value === undefined) {
                value = true;
            }

            this.profileCallInitiation = value;

            this.eachResource(function (r) {
                return r.profileCalls(value);
            });

            return this;
        }
    }, {
        key: 'proxy',
        value: function proxy(callProxy) {
            this.callProxy = new Proxy(callProxy);

            return this;
        }
    }, {
        key: 'getCredentialsUsing',
        value: function getCredentialsUsing(credentialsGatherer) {
            this.credentialsGatherer = credentialsGatherer;

            return this;
        }
    }, {
        key: 'handleFailedAuthenticationUsing',
        value: function handleFailedAuthenticationUsing(failedAuthenticationHandler) {
            this.failedAuthenticationHandler = failedAuthenticationHandler;

            return this;
        }
    }, {
        key: 'authenticate',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(username, password) {
                var productId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                var credentials, message;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!this.authToken) {
                                    _context.next = 4;
                                    break;
                                }

                                return _context.abrupt('return', { authToken: this.authToken, userType: this.userType });

                            case 4:
                                _context.prev = 4;

                                if (!(username === undefined)) {
                                    _context.next = 17;
                                    break;
                                }

                                if (!this.credentialsGatherer) {
                                    _context.next = 15;
                                    break;
                                }

                                _context.next = 9;
                                return this.getCredentials(this.setCredentials);

                            case 9:
                                credentials = _context.sent;


                                username = credentials.username;
                                password = credentials.password;

                                // Remember the username for future any calls to the credentials gatherer

                                this.username = username;
                                _context.next = 17;
                                break;

                            case 15:
                                message = 'Environment.authenticate() - you need to call getCredentialsUsing(),' + ' providing a function to gather the username and password';


                                this.log.scream(message);

                            case 17:
                                _context.next = 19;
                                return this.performAuthentication(username, password, productId);

                            case 19:
                                return _context.abrupt('return', _context.sent);

                            case 22:
                                _context.prev = 22;
                                _context.t0 = _context['catch'](4);

                                this.log.error('Environment.authenticate("' + username + '", "' + password + '") - caught an exception ...', _context.t0);

                            case 25:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[4, 22]]);
            }));

            function authenticate(_x, _x2) {
                return _ref2.apply(this, arguments);
            }

            return authenticate;
        }()
    }, {
        key: 'bypassAuthentication',
        value: function bypassAuthentication() {
            // this.log.warn(`Environment("${this.name}").bypassAuthentication()` +
            //                    '- setting requireAuthentication to false');

            this.requireAuthentication = false;
            this.authToken = 'AUTHENTICATION_BYPASSED';

            return this;
        }
    }, {
        key: 'substituteConfigurationItems',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(text) {
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                return _context2.abrupt('return', this.configuration.substituteConfigurationItems(text));

                            case 1:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function substituteConfigurationItems(_x4) {
                return _ref3.apply(this, arguments);
            }

            return substituteConfigurationItems;
        }()
    }, {
        key: 'getConfigurationItem',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(name) {
                var ignoreMissingItems = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                return _context3.abrupt('return', this.configuration.getItem(name, ignoreMissingItems));

                            case 1:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function getConfigurationItem(_x5) {
                return _ref4.apply(this, arguments);
            }

            return getConfigurationItem;
        }()

        // withConfigHost(host) {
        //     if (this.name === 'localhost') {
        //         let url = `http://${host}`;
        //
        //         if (this.configPort) {
        //             url += `:${this.configPort}`;
        //         }
        //
        //         this.configuration.host = this.host = url;
        //
        //         this.setConfigService();
        //     } else {
        //         const message = `withHost() can only be called for the "localhost" environment; this environment is "${this.name}".`;
        //
        //         this.log.scream(message);
        //     }
        //
        //     return this;
        // }
        //
        // withConfigService(configService) {
        //     this.configService = configService;
        //     this.configuration.configService = configService;
        //
        //     return this;
        // }

    }, {
        key: 'mockWith',
        value: function mockWith(data) {
            this.mockData = data;

            return this;
        }
    }, {
        key: 'deauthenticate',
        value: function deauthenticate() {
            this.authToken = undefined;
            this.JWT = undefined;
        }
    }, {
        key: 'reauthenticate',
        value: function reauthenticate() {
            authenticate(this.credentials);
        }
    }, {
        key: 'resource',
        value: function resource(name) {
            var resource = this.resources[name];

            if (!resource) {
                resource = this.resources[name] = new Resource(name, this.configuration);

                resource.chatty = this.chatty;

                // Define whether references to the resource must pass an authentication
                // token, based on what the environment says.  Generally this would be
                // true, but could be overridden for local testing purposes by calling
                // Environment.bypassAuthentication().

                resource.needsAuthentication = this.configuration.environment.requireAuthentication;
            }

            return resource;
        }

        // Implementation details ...

    }, {
        key: 'performAuthentication',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(username, password) {
                var productId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                var prefix, response;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                prefix = 'Environment("' + this.name + '").performAuthentication(\'' + username + '\', \'' + password + '\')';


                                this.authToken = undefined;
                                this.JWT = undefined;
                                this.username = username;

                                _context4.prev = 4;
                                _context4.next = 7;
                                return this.getAuthTokenAndUserType(username, password, productId);

                            case 7:
                                response = _context4.sent;

                                if (!response.authToken) {
                                    _context4.next = 15;
                                    break;
                                }

                                this.authToken = response.authToken;
                                // this.JWT = response.JWT; // Removed to force all other code to ignore any JWT received
                                this.userType = response.userType;

                                if (this.chatty) {
                                    this.log.debug(prefix + ' - succeeded with authToken ' + this.authToken);
                                }

                                return _context4.abrupt('return', { authToken: this.authToken, userType: this.userType });

                            case 15:
                                return _context4.abrupt('return', response);

                            case 16:
                                _context4.next = 21;
                                break;

                            case 18:
                                _context4.prev = 18;
                                _context4.t0 = _context4['catch'](4);

                                this.log.scream(prefix + ' - caught an exception ...', _context4.t0);

                            case 21:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this, [[4, 18]]);
            }));

            function performAuthentication(_x7, _x8) {
                return _ref5.apply(this, arguments);
            }

            return performAuthentication;
        }()
    }, {
        key: 'getAuthTokenAndUserType',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(username, password) {
                var productId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

                var prefix, code, message, configuration, environment, _resources, authentication, payload, data, authToken, userType;

                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                prefix = 'Environment("' + this.name + '").getAuthTokenAndUserType(\'' + username + '\', \'' + password + '\')';
                                code = undefined;
                                message = undefined;
                                _context5.prev = 3;
                                configuration = this.configuration;


                                configuration.getResources();

                                environment = configuration.environment;
                                _resources = environment.resources;
                                _context5.next = 10;
                                return _resources['authentication'].post().withBody({ userName: username, password: password, productId: productId }).verbose().send();

                            case 10:
                                authentication = _context5.sent;


                                code = authentication.code;
                                message = authentication.message;

                                if (!code) {
                                    _context5.next = 19;
                                    break;
                                }

                                this.log.scream(prefix + ' - the request failed with code "' + code + '" and message "' + message + '"');

                                payload = authentication.payload || {};
                                return _context5.abrupt('return', { code: code, message: message, payload: payload });

                            case 19:
                                data = authentication.data;
                                authToken = data.token;
                                // const JWT = data.jwtToken;

                                userType = data.user.type;


                                if (this.chatty) {
                                    this.log.debug(prefix + ' - succeeded with authToken ' + this.authToken);
                                }

                                return _context5.abrupt('return', { authToken: authToken, userType: userType });

                            case 24:
                                _context5.next = 32;
                                break;

                            case 26:
                                _context5.prev = 26;
                                _context5.t0 = _context5['catch'](3);

                                this.log.scream(prefix + ' - caught an exception ...', _context5.t0);

                                code = 'Exception';
                                message = _context5.t0.toString();

                                return _context5.abrupt('return', { code: code, message: message });

                            case 32:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this, [[3, 26]]);
            }));

            function getAuthTokenAndUserType(_x10, _x11) {
                return _ref6.apply(this, arguments);
            }

            return getAuthTokenAndUserType;
        }()
    }, {
        key: 'registerResource',
        value: function registerResource(resource) {
            resource.configuration = this.configuration;

            resources[resource.name] = resource;
        }
    }, {
        key: 'eachResource',
        value: function eachResource(update) {
            var keys = Object.keys(this.resources);

            for (var i = 0; i < keys.length; i++) {
                update(this.resources[keys[i]]);
            }
        }
    }]);

    return Environment;
}();

module.exports = Environment;


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/resource/lib/environment.js
// module id = N1nn
// module chunks = 0